import styled from 'styled-components'

const Body = styled.div`
  width: 100%;
  max-width: 520px;
`
export { Body }
